module.exports = __webpack_public_path__ + "static/img/Dx.aea0ae7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Dx.jpg
// module id = Mddf
// module chunks = 1